export default __webpack_public_path__ + "locales/uk-UA/ChangeUserStatusDialog.json?hash=1ed2cb227635e52ff03f580417c9bdac";